import * as React from "react";
import { render } from "react-dom";
import { Provider } from "react-redux";
import { STORE } from "./store";
import { RootHOC } from "./views/scaffolding/root";

require("./views/assets/style.css");
require("./views/assets/favicon/apple-icon-60x60.png");
require("./views/assets/favicon/apple-icon-57x57.png");
require("./views/assets/favicon/apple-icon-76x76.png");
require("./views/assets/favicon/apple-icon-114x114.png");
require("./views/assets/favicon/apple-icon-120x120.png");
require("./views/assets/favicon/apple-icon-144x144.png");
require("./views/assets/favicon/apple-icon-152x152.png");
require("./views/assets/favicon/apple-icon-180x180.png");
require("./views/assets/favicon/android-icon-192x192.png");
require("./views/assets/favicon/favicon-32x32.png");
require("./views/assets/favicon/favicon-96x96.png");
require("./views/assets/favicon/favicon-16x16.png");
require("./views/assets/favicon/ms-icon-144x144.png");

if (process.env.NODE_ENV === "development") {
  require("./views/assets/dev_styles.css");
}

/**
 * Applies the store to the root of the application tree as props and renders
 * it to the DOM.
 */
render(
  <Provider store={STORE}>
    <RootHOC />
  </Provider>,
  document.getElementById("app")
);

/**
 * If Webpack devserver considers this module "hot", changes to the app will
 * result in recompilation and served back into the app asynchronously.
 */
if (module.hot) {
  module.hot.accept();
}
